<section class="rates">
  <header class="rates__head">
    <h1 class="rates__title">US Treasury Rates</h1>
    <p class="rates__desc">
      Stored US Treasury yield-curve points by term. Filter by effective date —
      the latest curve is shown on load.
    </p>
  </header>

  <div class="rates__toolbar">
    <div class="field">
      <label for="asOfDate">As Of Date</label>
      <p-select
        inputId="asOfDate"
        [options]="dateOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="selectedDate"
        [style]="{ minWidth: '200px' }">
      </p-select>
    </div>
    <button
      pButton
      type="button"
      label="Refresh"
      icon="pi pi-refresh"
      [disabled]="loading"
      (click)="load()">
    </button>
  </div>

  @if (error) {
    <p class="rates__error" role="alert">{{ error }}</p>
  }

  <div class="rates__tablewrap">
    <div class="rates__caption">
      <span class="rates__caption-title">{{ selectedDateLabel }}</span>
      <span class="rates__caption-meta">{{ rows.length }} rows</span>
    </div>

    <p-table
      [value]="rows"
      [loading]="loading"
      [scrollable]="true"
      scrollHeight="520px"
      [paginator]="rows.length > 10"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      paginatorDropdownAppendTo="body"
      styleClass="p-datatable-sm p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Term</th>
          <th class="num">Rate (%)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ formatMonths(row.months) }}</td>
          <td class="num">{{ formatRate(row.rates) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2" class="rates__empty">No Treasury rates for this selection.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
